import React from 'react'

import styled from '@emotion/styled'

import CloseIcon from '../icons/CloseIcon'

const ModalHeaderRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 1rem;
  background: inherit;
  top: 0;

  ${props => props.theme.breakpoints.tablet} {
    padding: 1.5rem;
    padding-bottom: 0.5rem;
  }
`

const CloseButton = styled.button`
  appearance: none;
  cursor: pointer;
  display: inline-block;
  width: 2rem;
  height: 2rem;
  font-size: 2rem;
  background: inherit;
  border: none;
  outline-style: none;
  padding: 0;
  color: ${props => props.theme.colors.icon};
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;

  :disabled {
    cursor: not-allowed;
  }

  ${props => props.theme.selectors.keyboard} &:focus {
    outline-style: auto;
  }
`

export interface ModalHeaderProps {
  disableClose?: boolean
  onClose: () => void
  'aria-label'?: string
}

const ModalHeader = ({ disableClose, onClose, 'aria-label': ariaLabel = 'close' }: ModalHeaderProps) => (
  <ModalHeaderRow>
    <CloseButton disabled={disableClose} onClick={disableClose ? () => null : onClose} aria-label={ariaLabel}>
      <CloseIcon />
    </CloseButton>
  </ModalHeaderRow>
)

export default ModalHeader
